import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { SERVICES as DEFAULT_SERVICES } from "../data/services";

// Hook to fetch service image overrides from backend (admin-managed) and merge with defaults.
export function useServices() {
  const [services, setServices] = useState(DEFAULT_SERVICES);

  useEffect(() => {
    let alive = true;
    api.get("/service-images")
      .then((r) => {
        if (!alive) return;
        const overrides = (r.data || []).reduce((acc, x) => { acc[x.slug] = x.image_url; return acc; }, {});
        setServices(DEFAULT_SERVICES.map((s) => ({
          ...s,
          image: overrides[s.slug] || s.image,
        })));
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return services;
}
